import script from "./DynamicFormSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicFormSteps.vue?vue&type=script&setup=true&lang=js"

import "./DynamicFormSteps.vue?vue&type=style&index=0&id=48c635e9&lang=scss"

const __exports__ = script;

export default __exports__